module.exports = __webpack_public_path__ + "static/img/a019.7ed91a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a019.jpg
// module id = wzHQ
// module chunks = 0